interface TaiwanDistrict {
  name: string;
}

interface DevParsedAddress {
  administrative_area_level_1: string;
  administrative_area_level_2: string;
  route: string;
  street_number: string;
}

interface SelectOption {
  label: string;
  value: string;
}

import { isPracticeMode } from "@utils/practice/practiceMode";

const taiwanDistricts = require("../../../data/taiwanDistricts.json") as Record<string, TaiwanDistrict[]>;

const normalizeInput = (value: string) => value.replace(/\s+/g, "");

export const isLocalAddressDevBypassEnabled = () =>
  // 客服練習模式：任何環境都走離線地址資料（縣市/區用本地 JSON、手動解析地址）。
  isPracticeMode() ||
  (process.env.NODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    ["localhost", "127.0.0.1"].includes(window.location.hostname));

export const parseTaiwanAddressForDev = (rawAddress: string): DevParsedAddress | null => {
  const address = normalizeInput(rawAddress);
  if (!address) return null;

  const city = Object.keys(taiwanDistricts)
    .sort((a, b) => b.length - a.length)
    .find((cityName) => address.startsWith(cityName));
  if (!city) return null;

  let remaining = address.slice(city.length);
  const area = (taiwanDistricts[city] || [])
    .map((district) => district.name)
    .sort((a, b) => b.length - a.length)
    .find((districtName) => remaining.startsWith(districtName));
  if (!area) return null;

  remaining = remaining.slice(area.length);
  const numberMatch = remaining.match(/^(.*?)(\d+(?:-\d+)?(?:之\d+)?)號?(.*)$/);
  if (!numberMatch) {
    return {
      administrative_area_level_1: city,
      administrative_area_level_2: area,
      route: remaining,
      street_number: "",
    };
  }

  return {
    administrative_area_level_1: city,
    administrative_area_level_2: area,
    route: numberMatch[1] || "",
    street_number: numberMatch[2] || "",
  };
};

export const getLocalCityOptionsForDev = (): SelectOption[] =>
  Object.keys(taiwanDistricts)
    .sort((a, b) => a.localeCompare(b, "zh-Hant"))
    .map((city) => ({ label: city, value: city }));

export const getLocalAreaOptionsForDev = (city: string): SelectOption[] =>
  (taiwanDistricts[city] || [])
    .map((district) => district.name)
    .sort((a, b) => a.localeCompare(b, "zh-Hant"))
    .map((area) => ({ label: area, value: area }));
